<template>
  <v-dialog v-model="show" width="80%">
    <v-card>
      <v-card-title style="padding-left:8px;padding-bottom:8px">
        <span class="headline">{{$t('B0300.titles[4]')}}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search">{{$t('app.buttons.search')}}</v-btn>
        <v-btn @click="submit">{{$t('app.buttons.apply')}}</v-btn>
        <v-btn @click="show = false">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md4 sm6 xs12>
              <v-text-field :label="$t('app.labels.skuCode')" clearable v-model="query.code"></v-text-field>
            </v-flex>
            <v-flex md4 sm6 xs12>
              <v-text-field
                :label="$t('app.labels.skuSupplierCode')"
                clearable
                v-model="query.supplierCode"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
      <v-data-table
        :headers="headers"
        :items="pagination.content"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="code"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td width="20">
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.supplierCode }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      query: {},
      show: false,
      resolve: null,
      reject: null,
      selected: [],
      headers: [
        { text: this.$t('app.labels.skuCode'), value: 'code', sortable: false },
        {
          text: this.$t('app.labels.skuSupplierCode'),
          value: 'supplierCode',
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: 5,
        page: 1
      }
    }
  },
  methods: {
    search() {
      this.pagination.page = 1
      this.load()
    },
    load() {
      if (!this.show) return
      this.$http
        .get('skus', {
          params: { ...this.query, ...this.$pageable() }
        })
        .then(res => this.$pagination(res.data))
    },
    submit() {
      this.show = false
      this.resolve(
        this.selected.map(s => ({
          ...s,
          paid: 0
        }))
      )
      this.selected = []
    },
    popup() {
      this.show = true
      this.load()
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    }
  },
  watch: {
    pagination() {
      this.load()
    }
  }
}
</script>
